import type { CreateAgencyInput, UpdateAgencyInput } from '@idc-forms/schemas'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { queryKeys } from '@/shared/constants/query-keys'
import { getErrorMessage } from '@/shared/utils/handle-api-error'
import { createAgency, deleteAgency, updateAgency } from '../services/agencies-admin.service'

export const useCreateAgencyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: CreateAgencyInput) => await createAgency(payload),
    onSuccess: () => {
      toast.success('Agencia creada')
      void queryClient.invalidateQueries({ queryKey: queryKeys.agencies.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useUpdateAgencyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: UpdateAgencyInput }) =>
      await updateAgency(id, payload),
    onSuccess: () => {
      toast.success('Agencia actualizada')
      void queryClient.invalidateQueries({ queryKey: queryKeys.agencies.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useDeleteAgencyMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => await deleteAgency(id),
    onSuccess: () => {
      toast.success('Agencia eliminada')
      void queryClient.invalidateQueries({ queryKey: queryKeys.agencies.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}
